import { Component, Inject } from '@angular/core';
import { StateService } from "@uirouter/angular";
import { WorkplaceDataService } from "../../core/workplaces.dataservice";
import { MatDialog } from "@angular/material/dialog";
import { DetailsBase } from "../shared/details.base";

@Component({
    selector: "crew-workplace",
    template: require('../shared/details-view.html')
})
export class Workplace extends DetailsBase<Nema.Crew.Model.Workplace> {
    constructor(
        stateService: StateService,
        dialog: MatDialog,
        @Inject('workplace') workplace: Nema.Crew.Model.Workplace,
        @Inject('workplaceDataService') workplaceDataService: WorkplaceDataService,
        @Inject('$log') $log: ng.ILogService) {

        super(stateService, dialog, workplace, workplaceDataService, $log);
    }

    public entityName = "Workplace";

    public editStateName = "app.settings.workplaces.edit";

    public listStateName = "app.settings.workplaces";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/workplaces/workplace.component.ts